import { computed } from 'vue'
import type { SideMenuLanguage } from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/SideMenu.types'
import useTheHeaderSite from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/composables/useTheHeaderSite'
import useTheHeaderSiteLogo from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/composables/useTheHeaderSiteLogo'
import useTheHeaderProjects from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/composables/useTheHeaderProjects'
import useTheHeaderPersonalAreaUrl from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/composables/useTheHeaderPersonalAreaUrl'
import useTheHeaderSearchData from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/composables/useTheHeaderSearchData'

export default function useTheHeader() {
  const site = useTheHeaderSite()
  const { context, townSelectUrl } = site
  const { siteLogo } = useTheHeaderSiteLogo(site)
  const { projects } = useTheHeaderProjects(site)
  const { personalAreaUrl } = useTheHeaderPersonalAreaUrl()
  const { searchData } = useTheHeaderSearchData(site)

  const withoutAnalysesCart = computed(() => Boolean(context.without_analyses_cart))
  const analysesCountInCart = computed(() => Number(context.analyses_count_in_cart || 0))
  const expertUrl = computed(() => String(context.global?.sites?.siteNameExpert || ''))
  const availableLanguages = computed<SideMenuLanguage[]>(() => (
    Array.isArray((context as { available_languages?: SideMenuLanguage[] }).available_languages)
      ? (context as { available_languages?: SideMenuLanguage[] }).available_languages || []
      : []
  ))

  return {
    siteLogo,
    searchData,
    withoutAnalysesCart,
    analysesCountInCart,
    expertUrl,
    availableLanguages,
    townSelectUrl,
    projects,
    personalAreaUrl,
  }
}
